<template>
  <!-- 63、管理员-系统管理者  -->
  <div class="main-css">
    <!--  标题-->
    <div class="title-css">
      <p>{{ $t("adminSystemAdmin") }}</p>
    </div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="goToAdminRegister">{{
          $t("new")
        }}</el-button>
        <el-button class="button-css" @click="handleAlterClick">{{
          $t("changeState")
        }}</el-button>
        <el-button class="button-css" @click="handleDeleteClick">{{
          $t("delete")
        }}</el-button>
      </div>
      <!--    表格部分-->
      <div class="table">
        <el-table
          @cell-click="tableCellClick"
          ref="multipleTable"
          :data="tableData"
          :cell-class-name="
            ({ row, column, rowIndex, columnIndex }) => (
              (row.index = rowIndex), (column.index = columnIndex)
            )
          "
          style="width: 95%"
          height="520px"
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
          v-loading="loading"
        >
          <!--------------选择框----------------->
          <el-table-column type="selection" width="45"> </el-table-column>

          <!--------------番号----------------->
          <el-table-column
            prop="userId"
            label="番号"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("id") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="changeFuzzyQueryInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.userId"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.userId }}</span>
            </template>
          </el-table-column>
          <!--          &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;写真-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
          <!--          <el-table-column  label="写真" width="80" fixed="left">-->
          <!--            <template slot="header">-->
          <!--              <p>{{ $t("photograph") }}</p>-->
          <!--            </template>-->
          <!--            <template slot-scope="scope">-->
          <!--              <div v-if=" scope.row.index === tableCellClickRowIndex &&-->
          <!--            scope.column.index === tableCellClickColumnIndex">-->
          <!--                <div class="Avatar">-->
          <!--                  <div class="Avatar-img" @click="toGetImg(scope.row)" v-if="!imageUrl">-->
          <!--                    <p class="Avatar-img-icon">-->
          <!--                      <img src="./assets/Image_01.svg" alt=""  />-->
          <!--                    </p>-->
          <!--                    <p class="Avatar-img-title">{{ $t("photograph") }}</p>-->
          <!--                  </div>-->
          <!--                  <div class="Avatar-img" @click="toGetImg" v-if="imageUrl">-->
          <!--                    <img :src="imageUrl" alt="" class="Avatar-img-main-css" />-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div v-else>-->
          <!--                <img :src="scope.row.url" alt="" class="table-img-css"/>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--------------氏名----------------->
          <el-table-column
            prop="userName"
            label="氏名"
            min-width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="changeFuzzyQueryInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.userName"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <!--------------ユーザーID----------------->
          <el-table-column
            prop="emailAddress"
            label="ユーザーID"
            min-width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("userId") }}</p>
              <el-input
                v-model="emailAddress"
                size="mini"
                placeholder="Search"
                @input="changeFuzzyQueryInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.emailAddress"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.emailAddress }}</span>
            </template>
          </el-table-column>

          <!--------------登録日付----------------->
          <el-table-column
            prop="createTime"
            label="登録日付"
            sortable
            min-width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("Completion") }}</p>
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.createTime"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.createTime.substring(0, 10) }}</span>
            </template>
          </el-table-column>
          <!--------------最新修正日付----------------->
          <el-table-column
            prop="updateTime"
            label="最新修正日付"
            sortable
            min-width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("lastUpdataDay") }}</p>
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.updateTime"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.updateTime.substring(0, 10) }}</span>
            </template>
          </el-table-column>
          <!--------------最新ログイン----------------->
          <el-table-column
            prop="loginDate"
            label="最新ログイン"
            min-width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("lastLogin") }}</p>
              <el-input
                v-model="searchData8"
                size="mini"
                placeholder="Search"
                @input="changeFuzzyQueryInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.loginDate"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.loginDate.substring(0, 10) }}</span>
            </template>
          </el-table-column>
          <!--------------IP----------------->
          <el-table-column
            prop="ip"
            label="IP"
            min-width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("ip") }}</p>
              <el-input
                v-model="searchData9"
                size="mini"
                placeholder="Search"
                @input="changeFuzzyQueryInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.ip"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.ip }}</span>
            </template>
          </el-table-column>

          <!--------------状態----------------->
          <el-table-column prop="userStatus" label="状態" min-width="100px">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <el-input
                v-model="searchData11"
                size="mini"
                placeholder="Search"
                @input="changeFuzzyQueryInfo"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.userStatus"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.userStatus_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpuserStatus_dictText }}
              </span>
            </template>
          </el-table-column>

          <!--------------操作----------------->
          <el-table-column label="操作" fixed="right" min-width="280">
            <template slot="header">
              <p>{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <button class="save-button" @click="handleSaveClick(scope.row)">
                {{ $t("save") }}
              </button>
              <button
                class="save-button"
                @click="handleResetPasswordClick(scope.row)"
              >
                {{ $t("resetPassword") }}
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template>
        <el-dialog :visible.sync="dialogEmilIsSHow" width="35%">
          <div>
            <p class="dialog-title">{{ $t("passwordReissue") }}</p>
            <p class="dialog-hint">{{ $t("popupPrompts") }}</p>
          </div>
          <!--邮箱地址-->
          <div class="dialog-emil-input">
            <div class="emil-input">
              <div class="emil-input-css">
                <img src="./assets/Vector (1).png" alt="" class="emil-icon" />
                <input
                  type="text"
                  class="emil-input-css-main"
                  v-model="userId"
                />
              </div>
            </div>
          </div>
          <!--密码-->
          <div class="dialog-emil-input">
            <div class="emil-input">
              <div class="emil-input-css">
                <img src="./assets/Vector(2).png" alt="" class="emil-icon" />
                <input
                  type="text"
                  class="emil-input-css-main"
                  v-model="password"
                />
              </div>
            </div>
          </div>
          <!--确认密码-->
          <div class="dialog-emil-input">
            <div class="emil-input">
              <div class="emil-input-css">
                <img src="./assets/Vector(2).png" alt="" class="emil-icon" />
                <input
                  type="text"
                  class="emil-input-css-main"
                  v-model="repassword"
                />
              </div>
            </div>
          </div>
          <!--按钮-->
          <div class="dialog-button-css">
            <button class="dialog-emil-button" @click="handleCloseDialog">
              {{ $t("passwordReissue") }}
            </button>
          </div>
        </el-dialog>
      </template>
      <!--    分页部分-->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalNum"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryAllUserInfo,
  batchDelete,
  fuzzyQueryUserInfo,
  stateChanges,
  resetPassword,
  updateAdminInfo
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "adminTalentManagement",
  components: {},
  data() {
    return {
      userId: "",
      password: "",
      repassword: "",
      imageUrl: "",
      valueUrl: "",
      emailAddress: "", //邮箱地址
      tableCellClickRowIndex: null, // 点击的单元格行索引
      tableCellClickColumnIndex: null, // 点击的单元格列索引
      tableData: [],
      multipleSelection: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "",
      searchData8: "",
      searchData9: "",
      searchData10: "",
      searchData11: "",
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      dialogEmilIsSHow: false, //dialog标识
      totalNum: 0,
      language: ""
    };
  },

  created() {
    //生命周期，打开页面时调用
    //获取数据字典语言值方法
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);

    this.pageInfoDTO();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.pageInfoDTO();
      }
    },
    //dialog 关闭
    handleCloseDialog() {
      if (this.password === null || this.password.length == 0) {
        this.$message({
          message: this.$t("enterPassword"),
          type: "warning"
        });
      } else if (this.repassword === null || this.repassword.length == 0) {
        this.$message({
          message: this.$t("pleaseEnterPasswordAgain"),
          type: "warning"
        });
      } else if (this.password != this.repassword) {
        this.$message({
          message: this.$t("inconsistentPasswordEnteredTwice"),
          type: "warning"
        });
      } else {
        var platformAdminResetDTO = {
          password: this.password,
          userId: this.userId
        };
        resetPassword(platformAdminResetDTO)
          .then(res => {
            console.log("--------管理员重置密码数据--------");
            console.log(res);
            if (res.data.code === "A0000") {
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              console.log(aesFecInfo);
              this.$message({
                message: this.$t("upSuccess"),
                type: "success"
              });
              this.password = "";
              this.repassword = "";
              this.dialogEmilIsSHow = false;
            } else {
              this.$message({
                message: AES.decrypt(res.data.data),
                type: "error"
              });
            }
          })
          .catch(res => {});
      }
    },

    tableCellClick(row, column, cell, event) {
      this.tableCellClickRowIndex = row.index;
      this.tableCellClickColumnIndex = column.index;
    },
    // 单元格失去焦点
    tableCellInputBlur(row, event, column) {
      this.tableCellClickRowIndex = null;
      this.tableCellClickColumnIndex = null;
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },
    handleCurrentChange(evt) {
      this.currentPage = evt;
      this.pageInfoDTO();
      console.log(this.currentPage);
    },
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.pageInfoDTO();
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      for (var i = 0; i < val.length; i++) {
        this.multipleSelection.push(val[i].userId);
        this.userId = val[0].userId;
        this.userStatus = val[0].userStatus;
      }
    },
    goToAdminRegister() {
      this.$router.push("/adminRegister");
    },
    handleAlterClick() {
      console.log("状態変更button");
      if (this.multipleSelection.length === 0) {
        this.$message({
          showClose: true,
          message: this.$t("pleaseSelectUser"),
          type: "warning"
        });
      } else if (this.multipleSelection.length > 1) {
        this.$message({
          showClose: true,
          message: this.$t("AtMostOneUserSelected"),
          type: "warning"
        });
      } else {
        if (this.userStatus === "1") {
          this.userStatus = "0";
        } else {
          this.userStatus = "1";
        }
        var fakeInfo = {
          userId: this.userId,
          userStatus: this.userStatus
        };
        stateChanges(fakeInfo)
          .then(res => {
            console.log("--------管理员状态变更接口--------");
            console.log(res);
            if (res.data.code === "A0000") {
              this.$message.success("身份变更成功。");
              this.pageInfoDTO();
            } else {
              this.$message.error("身份变更失败。");
            }
          })
          .catch(res => {});
      }
    },
    handleDeleteClick() {
      console.log("削除button");
      if (this.multipleSelection.length === 0) {
        this.$message({
          showClose: true,
          message: this.$t("pleaseSelectTheUserYouWantToDelete"),
          type: "warning"
        });
      } else {
        var listInfo = {
          listId: this.multipleSelection
        };
        batchDelete(listInfo)
          .then(res => {
            console.log("批量删除平台管理员用户接口数据", res);
            if (res.data.code === "A0000") {
              this.pageInfoDTO();
              this.$message({
                message: this.$t("successfullyDeleted"),
                type: "success"
              });
            } else {
              this.$message({
                message: this.$t("failedToDelete"),
                type: "warning"
              });
            }
          })
          .catch(res => {
            console.log("批量删除平台管理员用户接口数据", res);
          });
      }
    },

    handleClick(evt) {
      if (evt === "0") {
        //长期
        console.log("长大");
      } else {
        //短期
        console.log("短大");
      }
    },
    // 管理员查询所有用户
    pageInfoDTO() {
      var allUser = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      queryAllUserInfo(allUser)
        .then(res => {
          console.log("-----平台管理员用户全部查询-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalNum = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
          } else {
            this.$message({
              message: this.$t("loginFailed"),
              type: "warning"
            });
          }
        })
        .catch(res => {});
    },
    //测试平台管理员用户模糊查询接口
    changeFuzzyQueryInfo() {
      var platformAdminUserDTO = {
        createTimeIn: "", //创建时间开始时间    false
        createTimeOut: "", //	创建时间结束时间		false
        emailAddress: this.searchData3, //	邮箱地址		false
        ip: this.searchData9, //IP地址		false
        pageNumber: this.currentPage, //下标		false
        pageSize: this.pageSize, //每页显示数据		false
        updateTimeIn: "", //更新时间开始时间		false
        updateTimeOut: "", //更新时间结束时间		false
        userName: this.searchData2, //	用户名		false
        userStatus: this.searchData11 //用户状态		false
      };

      fuzzyQueryUserInfo(platformAdminUserDTO)
        .then(res => {
          console.log("--------平台管理员用户模糊查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const AesDeInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(AesDeInfo);
            this.tableData = AesDeInfo.data;
          }
        })
        .catch(res => {
          console.log("平台管理员用户模糊查询接口数据异常:", res);
        });
    },

    handleResetPasswordClick(row) {
      this.dialogEmilIsSHow = true;
      this.userId = row.userId;
    },
    handleSaveClick(row) {
      // if(this.imageUrl == null ||this.imageUrl.length===0){
      // }else {
      //   row.url=this.imageUrl;
      // }
      // this.imageUrl="";
      console.log("保存button");
      var platformAdminEditDTO = {
        avatar: "1",
        emailAddress: row.emailAddress,
        userId: row.userId,
        userName: row.userName
      };
      updateAdminInfo(platformAdminEditDTO)
        .then(res => {
          console.log("--------管理员修改数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("successfullyModified"),
              type: "success"
            });
          } else {
            this.$message({
              message: this.$t("failToEdit"),
              type: "warning"
            });
          }
        })
        .catch(res => {});
      console.log(platformAdminEditDTO);
    }
  }
};
</script>

<style scoped>
.forget-password {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.password-dialog {
  width: 498px;
  height: 266px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 15px;
  box-sizing: border-box;
}
.dialog-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  color: #686868;
}
.dialog-hint {
  margin-left: 17px;
  width: 434px;
  height: 48px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  margin-top: 13px;
}
.dialog-emil-input {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  height: 60px;
}
.dialog-emil-button {
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  color: #51abff;
}
.dialog-emil-hint {
  margin-top: 5px;
  text-align: right;
  padding-right: 15px;
  box-sizing: border-box;
  color: #f56c6c;
}
.dialog-button-css {
  text-align: center;
  margin-top: 20px;
}
.emil-input {
  padding: 0px;
  width: 324px;
  height: 66px;
  margin-bottom: 10px;
}
.emil-icon {
  margin-right: 10px;
  margin-left: 15px;
}
.emil-input-css-main {
  width: 240px;
  margin-right: 10px;
  height: 34px;
  line-height: 34px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}
.emil-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 320px;
  box-sizing: border-box;
}
.emil-input-css img {
  margin-top: 13px;
}
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-box {
  /*表格*/
  margin-top: 0px;
  width: 100%;
  height: 0;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}
.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
  margin-top: 10px;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}
.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.operate {
  height: 51px;
}

.table {
  position: absolute;
  width: 92%;
  margin-top: 10px;
  height: 580px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans", serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.table /deep/ .el-dropdown {
  /*下拉框*/
  width: 60px;
}
.table-img-css {
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50%;
}
.el-dropdown-link {
  /*下拉框*/
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}
.one-box-left {
  width: 200px;
  height: 100px;
  padding-left: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.Avatar {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Avatar-img {
  width: 50px;
  height: 50px;
  background: #51abff;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
}
.Avatar-img-icon {
  margin-top: 15px;
}
.Avatar-img-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}
.save-button {
  width: 120px;
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-top: 1px;
}

.pagination {
  /*分页*/
  width: 95%;
  height: 50px;
  margin-top: 590px;
}
.pagination-main {
  /*分页*/
  float: right;
  margin-right: 10px;
  display: flex;
}
.rowsPage {
  /*RowsPage*/
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorSystemAdministrator/index.vue